module.exports = __webpack_public_path__ + "static/necromancer_icon-87dd68ccb8d8c2e6464f0041e595d9b1.png";